<script setup lang="ts">
import { onMounted } from "vue"
import { useTheme } from "@/lib/theme"
import LocaleSwitcher from "@/components/LocaleSwitcher.vue"
import { useAuthStore } from "@/stores/auth"
import { usePublicStore } from "@/stores/public"

const auth = useAuthStore()
const publicStore = usePublicStore()
const { isDark, toggle } = useTheme()
onMounted(() => void publicStore.load().catch(() => undefined))
</script>

<template>
  <div class="public-layout">
    <header class="public-header">
      <RouterLink class="brand" to="/" :aria-label="$t('CodexNow home')"><span class="brand-mark">C</span>{{ $t("CodexNow") }}</RouterLink>
      <nav class="public-nav" :aria-label="$t('Main navigation')">
        <RouterLink to="/pricing">{{ $t("Pricing") }}</RouterLink>
        <RouterLink to="/models">{{ $t("Models") }}</RouterLink>
        <RouterLink to="/docs">{{ $t("Docs") }}</RouterLink>
      </nav>
      <div class="header-actions">
        <LocaleSwitcher />
        <button class="icon-button" type="button" :aria-label="isDark ? $t('Use light theme') : $t('Use dark theme')" @click="toggle">
          {{ isDark ? "☀" : "☾" }}
        </button>
        <RouterLink v-if="auth.authenticated" class="button secondary small" to="/dashboard">{{ $t("Dashboard") }}</RouterLink>
        <template v-else>
          <RouterLink class="button ghost small" to="/login">{{ $t("Sign in") }}</RouterLink>
          <RouterLink v-if="publicStore.config?.registrationEnabled !== false" class="button primary small hide-mobile" to="/register">
            {{ $t("Get started") }}</RouterLink>
        </template>
      </div>
    </header>
    <main class="public-main"><RouterView /></main>
    <footer class="public-footer">
      <RouterLink class="brand brand-small" to="/"><span class="brand-mark">C</span>{{ $t("CodexNow") }}</RouterLink>
      <p>{{ $t("Provider-neutral, prepaid access to operator-configured AI models.") }}</p>
      <div><RouterLink to="/docs">{{ $t("API docs") }}</RouterLink><RouterLink to="/pricing">{{ $t("Pricing") }}</RouterLink>
        <a v-if="publicStore.config?.supportEmail" :href="`mailto:${publicStore.config.supportEmail}`">{{ $t("Support") }}</a></div>
    </footer>
  </div>
</template>
